import { useParams } from 'react-router-dom'

import AuthenticatedLayout from 'src/app/router/layouts/authenticated-layout'
import PublicProfileLayout from 'src/app/router/layouts/public-profile-layout'
import ErrorPage from 'src/app/router/routes/error'
import { useAuthState } from 'src/shared/features/auth/api/use-auth-state'

import InAppUserProfileView from './in-app-profile-view'
import PublicUserProfileView from './public-profile-view'

const GeneralUserProfileView = () => {
  const { isSignedIn } = useAuthState()
  const { username } = useParams<{ username: string }>()

  if (!username || typeof username !== 'string') {
    return <ErrorPage title="User not found" description="The user you are looking for does not exist." />
  }

  return isSignedIn ? (
    <AuthenticatedLayout hideFooter>
      <InAppUserProfileView username={username} />
    </AuthenticatedLayout>
  ) : (
    <PublicProfileLayout profile>
      <PublicUserProfileView username={username} />
    </PublicProfileLayout>
  )
}

export default GeneralUserProfileView
